import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mess15",
  "use": "icon-mess15-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mess15\"><path d=\"M816 400c0-139.904-95.12-257.712-224-292.96V0H432v107.04C303.12 142.288 208 260.096 208 400v297.376l-112 112V896h256.944c8 71.888 69.056 128 143.056 128s135.056-56.112 143.056-128H928v-86.624l-112-112V400z m-32 240H240v-64h544v64zM464 32h96v68.176C544.336 97.664 528.368 96 512 96s-32.336 1.664-48 4.176V32z m48 96c149.984 0 272 122.016 272 272v144H240v-144c0-149.984 122.016-272 272-272z m-16 864c-56.32 0-102.928-41.808-110.72-96h221.44c-7.792 54.192-54.4 96-110.72 96z m400-169.376V864H128v-41.376l112-112V672h544v38.624l112 112z\" fill=\"\" p-id=\"26472\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-mess15.svg
// module id = VKSR
// module chunks = 175